import {
  PatientHaudyPage as Component,
  PatientHaudyPageProps,
} from "../../../components/pages/patientHaudy/PatientHaudyPage";
import { useCheckUserRole, useListDataWithLoadMore } from "../../../hooks";
import { GET_HAUDY_USERS } from "../../../graphql/queries";
import { parseHaudyPatients } from "../../../graphql/utils";
import { useNavigate } from "react-router";

export const PatientHaudyPage = () => {
  const navigate = useNavigate();

  useCheckUserRole();

  const {
    data,
    variables: { keyword, order },
    handlers: { onSearchClick, onResetClick, onSortClick, onLoadMoreClick },
  } = useListDataWithLoadMore(
    GET_HAUDY_USERS,
    "haudyUsers",
    "処方情報は全て表示されています",
  );

  if (!data?.haudyUsers) {
    return null;
  }

  const props: PatientHaudyPageProps = {
    patients: parseHaudyPatients(data.haudyUsers),
    searchValue: keyword,
    order,
    onSearchClick,
    onResetClick,
    onSortClick,
    onRowClick: (patientId: string) => navigate(`/patient_haudy/${patientId}`),
    onLoadMoreClick,
  };

  return <Component {...props} />;
};
